<template>
  <router-view />
</template>
<script>
export default {
  name: "activity"
}
</script>